module.exports = __webpack_public_path__ + "img/scene5.20e0b026.png";